import ChartHeader from '../ChartHeader';
import am5themes_Animated from '@amcharts/amcharts5/themes/Animated';
import { Box } from '@mui/material';
import { useLayoutEffect, useRef, useState } from 'react';
import * as am5 from '@amcharts/amcharts5';
import * as am5percent from '@amcharts/amcharts5/percent';

const OverallCompletionChart = ({ data, onRefresh, isFirstLoad }) => {
  const chartRef = useRef(null);
  const [isManualRefreshing, setIsManualRefreshing] = useState(false);

  const handleManualRefresh = async () => {
    setIsManualRefreshing(true);
    if (onRefresh) {
      await onRefresh();
    }
    setTimeout(() => setIsManualRefreshing(false), 500);
  };

  const filteredData =
    data?.pending?.count < 0
      ? {
          completed: { count: data?.completed?.count, percentage: 0 },
          pending: { count: 0, percentage: 0 }
        }
      : data;

  useLayoutEffect(() => {
    // Create root
    const root = am5.Root.new(chartRef.current);

    // Set themes
    root.setThemes([am5themes_Animated.new(root)]);

    // Remove logo.
    root._logo.dispose();

    // Create chart
    const chart = root.container.children.push(
      am5percent.PieChart.new(root, {
        radius: am5.percent(90),
        innerRadius: am5.percent(50),
        layout: root.horizontalLayout,
        paddingRight: 120
      })
    );

    // Create series
    const series = chart.series.push(
      am5percent.PieSeries.new(root, {
        name: 'Survey Completion',
        categoryField: 'category',
        valueField: 'count',
        legendLabelText: '{category}',
        legendValueText: '{valuePercentTotal.formatNumber("#.0")}% ({value})',
        fillField: 'color'
      })
    );

    // Set data
    const chartData = [
      {
        category: 'Completed',
        count: filteredData.completed.count,
        color: am5.color('#336F9C')
      },
      {
        category: 'Pending',
        count: filteredData.pending.count,
        color: am5.color('#D77B30')
      }
    ];

    series.data.setAll(chartData);

    // Add legend
    const legend = chart.children.push(
      am5.Legend.new(root, {
        centerY: am5.percent(50),
        y: am5.percent(50),
        layout: root.verticalLayout
      })
    );

    legend.data.setAll(series.dataItems);

    // Play initial series animation
    if (isFirstLoad) {
      series.appear(1000, 100);
    }

    return () => {
      root.dispose();
    };
  }, [data]);

  return (
    <Box>
      <ChartHeader
        title='Overall survey completion'
        description='This chart shows the distribution of completed vs pending responses.'
        showRefreshButton={true}
        handleManualRefresh={handleManualRefresh}
        isRefreshing={isManualRefreshing}
      />
      <Box ref={chartRef} style={{ width: '100%', height: 'calc(100vh - 450px)' }} />
    </Box>
  );
};

export default OverallCompletionChart;
